"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSafeBuy = function SvgSafeBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.218 14.976a.999.999 0 01-.436 0A8.67 8.67 0 011 6.499V3.5A2.5 2.5 0 013.5 1h9A2.5 2.5 0 0115 3.5v3a8.669 8.669 0 01-6.782 8.476zM14 6.5v-3A1.5 1.5 0 0012.5 2h-9A1.5 1.5 0 002 3.5v3A7.669 7.669 0 008 14a7.67 7.67 0 006-7.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.969 3.3a.571.571 0 01.434.682l-.107.488a2.818 2.818 0 01.613.307c.246.163.24.506.03.714-.224.221-.59.196-.87.05l-.02-.01a1.355 1.355 0 00-.623-.144c-.252 0-.477.07-.675.209a.643.643 0 00-.296.55c0 .113.042.219.126.318.087.098.2.189.336.27.136.081.286.166.448.253.166.084.33.183.493.296.165.11.316.234.453.37a1.657 1.657 0 01.462 1.168c0 .359-.1.686-.3.982a2.017 2.017 0 01-.803.69 2.4 2.4 0 01-.752.225l-.114.518a.571.571 0 11-1.116-.246l.077-.353c-.16-.043-.315-.1-.465-.171a3.123 3.123 0 01-.615-.389c-.23-.187-.208-.53.01-.73.235-.214.603-.178.864.005a1.655 1.655 0 001.01.32c.159 0 .314-.03.465-.091a.995.995 0 00.392-.292.71.71 0 00.162-.458.689.689 0 00-.131-.41 1.17 1.17 0 00-.331-.322 5.34 5.34 0 00-.453-.266 9.65 9.65 0 01-.493-.284 3.156 3.156 0 01-.453-.335 1.428 1.428 0 01-.335-.458 1.484 1.484 0 01-.126-.62c0-.345.094-.658.283-.937.189-.279.444-.495.767-.65.259-.126.54-.201.842-.226l.13-.587a.571.571 0 01.68-.435z",
    fill: props.color
  }));
};

SvgSafeBuy.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgSafeBuy.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgSafeBuy;
exports["default"] = _default;
module.exports = exports.default;